/**
 * Wishlist Drawer Trigger
 * Handles opening the wishlist drawer when the wishlist icon is clicked in the header
 */
class WishlistDrawerTrigger {
  constructor() {
    this.wishlistIcon = null;
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.#setupWishlistIcon());
    } else {
      this.#setupWishlistIcon();
    }
  }

  #setupWishlistIcon() {
    // Find the wishlist icon in the utilities section
    const utilitiesSection = document.querySelector('.rr-desktop-top-nav .utilities-section');
    if (!utilitiesSection) return;

    // Find all utility icons (links or buttons)
    const utilityIcons = Array.from(utilitiesSection.querySelectorAll('a.utility-icon, button.utility-icon'));
    
    // Find the wishlist icon by checking href, data attributes, or icon content
    let wishlistIcon = utilityIcons.find(icon => {
      const href = icon.href ? icon.href.toLowerCase() : '';
      const iconElement = icon.querySelector('.utility-icon, .svg-wrapper');
      
      // Check if href contains wishlist
      if (href.includes('wishlist')) return true;
      
      // Check if icon contains heart-related classes or SVG
      if (iconElement) {
        const iconHTML = iconElement.innerHTML.toLowerCase();
        const iconClasses = iconElement.className.toLowerCase();
        if (iconHTML.includes('heart') || iconClasses.includes('heart') || 
            iconHTML.includes('wishlist') || iconClasses.includes('wishlist')) {
          return true;
        }
      }
      
      return false;
    });

    // If not found, try to find by position (usually after account icon)
    if (!wishlistIcon && utilityIcons.length >= 2) {
      const accountIcon = utilityIcons.find(icon => {
        const href = icon.href ? icon.href.toLowerCase() : '';
        return href.includes('account') || href.includes('login') || href.includes('customer');
      });
      
      if (accountIcon) {
        const accountIndex = utilityIcons.indexOf(accountIcon);
        // Wishlist is usually right after account
        if (accountIndex < utilityIcons.length - 1) {
          wishlistIcon = utilityIcons[accountIndex + 1];
        }
      }
    }

    if (!wishlistIcon) return;

    this.wishlistIcon = wishlistIcon;

    // Add click handler to open wishlist drawer
    wishlistIcon.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      // Dispatch event to open wishlist drawer
      document.dispatchEvent(new CustomEvent('openWishlistDrawer'));
    });

    // Update aria-label for accessibility if not already set
    if (!wishlistIcon.getAttribute('aria-label')) {
      wishlistIcon.setAttribute('aria-label', 'Open wishlist');
    }

    // Handle keyboard navigation (buttons already handle this, but ensure it works)
    wishlistIcon.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('openWishlistDrawer'));
      }
    });
  }
}

// Initialize
new WishlistDrawerTrigger();

